var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "action item-container", class: _vm.style() },
    [
      _c(
        "div",
        {
          staticClass: "action full-width flex-between",
          on: { click: _vm.clickHandler }
        },
        [
          _c("div", { staticClass: "flex-between label-name" }, [
            _vm._v(_vm._s(_vm.name))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex-between label-value" },
            [
              _c("span", { staticClass: "margin-right link" }, [
                _vm._v(_vm._s(_vm.value))
              ]),
              _vm._v(" "),
              _vm.accessory
                ? _c("BaseIcon", {
                    class: _vm.iconStyle(),
                    attrs: {
                      icon: _vm.accessory,
                      isCustom: _vm.determineCustom(_vm.accessory)
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d51efc04", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d51efc04","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseActionItem.vue
// module id = null
// module chunks = 